import { ICustomerProfileMembershipPackage } from "@/api_framework/api_modals/Users";
import SlideoverWithStickyFooter from "@/app/components/ui/SlideOvers/SlideoverWithStickyFooter";
import { useSlideoverState } from "@/app/hooks/ui_hooks/useSlideoverState";

import clsx from "clsx";
import { orderBy } from "lodash";

interface IMembershipDetailsSlideoverState {
  membershipPackage: ICustomerProfileMembershipPackage;
}
const MembershipDetailsSlideover = () => {
  const { membershipPackage } = useSlideoverState(
    "CUSTOMER_PROFILE_MEMBERSHIP_DETAILS",
  ) as IMembershipDetailsSlideoverState;

  const DateConversionFunction = (usage_date: string) => {
    const date = new Date(usage_date);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;
    return formattedDate;
  };
  return (
    <SlideoverWithStickyFooter
      title={<span className="font-bold">Membership Usage Details</span>}
      slideoverId="CUSTOMER_PROFILE_MEMBERSHIP_DETAILS"
    >
      <div className="">
        <p className="text-md text-gray-600 font-bold">Membership</p>
        <p className="text-xs pt-2 pb-2 text-gray-700   block break-words">{membershipPackage?.membership_name}</p>
        <ul role="list" className="space-y-6">
          {membershipPackage?.membership_package.map((mp, idx) => (
            <>
              <li key={`${mp.membership_type}:${idx}`} className="relative flex gap-x-4">
                <div className={clsx("absolute left-0 top-0 flex w-6 justify-center -bottom-6")}>
                  <div className="w-px bg-gray-200" />
                </div>
                <>
                  <div className="relative flex h-6 w-6 flex-none items-center justify-center bg-white">
                    <div className="h-1.5 w-1.5 rounded-full bg-blue-400 ring-1 ring-blue-500" />
                  </div>
                  <div className="">
                    <p className="flex-auto py-0.5 text-xs leading-5 text-gray-500">
                      <span className="font-medium text-gray-900">{mp.membership_type}</span> Type
                    </p>
                  </div>
                </>
              </li>
              <li className="relative flex gap-x-4 pl-7">
                <div className={clsx("absolute left-0 top-0 flex w-6 justify-center -bottom-6")}>
                  <div className="w-px bg-gray-200" />
                </div>
                <>
                  <div className="">
                    <p className="text-xs text-gray-500 font-semibold py-2">Package Usage</p>
                    {orderBy(mp.membership_usage, "invoice_date", "desc")?.map((usage, idx) => {
                      return (
                        <p
                          key={`usage:${idx}`}
                          className="flex justify-start items-center py-0.5 text-xs leading-5 text-gray-500"
                        >
                          <div className="relative flex h-6 w-6 flex-none items-center justify-center bg-white">
                            <div className="h-1.5 w-1.5 rounded-full bg-gray-400 ring-1 ring-gray-500" />
                          </div>
                          <div className="flex flex-col justify-start items-start">
                            <span className="font-medium text-gray-900">{usage.clinic}</span>
                            <span>Usage Date : {DateConversionFunction(usage.invoice_date)}</span>
                          </div>
                        </p>
                      );
                    })}
                  </div>
                </>
              </li>
            </>
          ))}
        </ul>
      </div>
    </SlideoverWithStickyFooter>
  );
};

export default MembershipDetailsSlideover;
